/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { z } from 'zod/v4';

export const skippedBulkDependencySchema = z.object({
  itemId: z.int(),
  reason: z.enum(['SELF_REFERENCE', 'DIRECT_CYCLE', 'ALREADY_EXISTS', 'PARENT_CHILD', 'NOT_FOUND']),
  targetId: z.int(),
});
